
export enum SaBannerType {
    Info,
    Warning,
    Error
}

export enum SaBannerMsgAlignment {
    Left = 'left',
    Center = 'center',
    Right = 'right',
}

export class SaBannerInfo {

    constructor(json: any = null) {
        if (json) {
            Object.assign(this, json);
        }
    }

    type: SaBannerType = SaBannerType.Info;
    message: string;
    messageAlignment = SaBannerMsgAlignment.Left
    allowClose: boolean = false;
}
